angular.module("alk.constants", []);


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-constants/module.js